export const environment = {
  production: false,
  apiUrl: 'https://erp.softqu.com',
  appName: 'Seventy-Seven',
  devFeature: true,
};
